import { Message } from 'element-ui';
/**
 * @description 过滤对象中的空值（空字符串、空对象、空数组、null、undefined）
 * @param {Object} obj 待处理对象
 * @returns {Object} 处理后的真值对象
 */
export const removeFalsyValues = obj => {
    return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) =>
            (!(value === '' || value === null || value === undefined)) &&
            (!(Array.isArray(value) && value.length === 0)) &&
            (!(typeof value === 'object' && Object.keys(value).length === 0))
        )
    );
};

/**
 * @description 校验查询时间跨度不能超过指定日期
 * @param {Object} searchData 查询参数
 * @param {String} sDateField 查询起始时间字段名
 * @param {String} eDateField 查询结束时间字段名
 * @param {String} maxSearchDay 最大时间跨度
 */
export const validateSearchTime = (searchData, sDateField, eDateField, maxSearchDay = 31, searchType = '时间') => {
    if (searchData[sDateField] && searchData[eDateField]) {
        const sDateTimeStamp = new Date(searchData[sDateField]).getTime();
        const eDateTimeStamp = new Date(searchData[eDateField]).getTime();
        const maxDay = 1000 * 60 * 60 * 24 * (maxSearchDay + 1); // OTP时间组件原因，得加多一天
        if (eDateTimeStamp - sDateTimeStamp > maxDay) {
            Message.warning(`按${searchType}查询或导出时，查询或导出时间跨度不可超过${maxSearchDay}天`);
            return false;
        }
    }
    return true;
};

/**
 * @description 处理查询参数
 * @param {Object} obj 待处理的查询参数对象
 * @param {Object} config 页面配置项
 * @returns {Array} outer：外部查询条件，inner：高级查询条件，keyMap:所有类型为advance的keyMap
 */
export const formatRouteParams = (obj, config) => {
    const searchTxt = config.searchList.searchTxt.map(v => v.value);
    const searchTotalTitle = config.searchTotalTitle.map(v => v.value);
    const outerAdvance = config.searchList.searchTxt.filter(v => v.type === 'advance' && Object.keys(obj).includes(v.value)).map(v => v.value);
    const innerAdvance = config.searchTotalTitle.filter(v => v.type === 'advance' && Object.keys(obj).includes(v.value)).map(v => v.value);
    const [outerAdvanceList, innerAdvanceList, keyMap] = processAdvanceList(outerAdvance, innerAdvance);
    const outer = Object.fromEntries(Object.entries(obj).filter(([key]) => searchTxt.includes(key) || outerAdvanceList.includes(key)));
    const inner = Object.fromEntries(Object.entries(obj).filter(([key]) => searchTotalTitle.includes(key) || innerAdvanceList.includes(key)));
    return [outer, inner, keyMap];
};

export const setValue = (targetObject, sourceObject) => {
    Object.entries(sourceObject).forEach(([key, value]) => {
        targetObject[key] = value;
    });
};

export const setAllPropertyValuesToNull = obj => {
    if (!obj) return;
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && key !== 'batchQueryKey') {
            obj[key] = null;
        }
    }
};
